import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoadingControl from '../../../components/LoadingControl';
import SurveyActivityV3AgentScreen from './agents/SurveyActivityV3AgentScreen';
import CalibrationV3AgentScreen from '../CalibrationScreenV3/agents/CalibrationV3AgentScreen';
import SurveyActivityV3ManagerScreen from './manager/SurveyActivityV3ManagerScreen';

import { pageLoaded } from '../../../utils';
import { ZRole } from '../../../generated';

class SurveyActivityScreen extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        pageLoaded('Survey Activity');
    }

    render() {
        const
            {
                currentUser,
            } = this.props;
        if (!currentUser) {
            return <LoadingControl />;
        }
        
        if (currentUser.RoleId == ZRole.Agent) {
            return <CalibrationV3AgentScreen />
        }
        else if (currentUser.RoleId == ZRole.Supervisor ||
            currentUser.RoleId == ZRole.Manager ||
            currentUser.RoleId == ZRole.Admin ||
            currentUser.RoleId == ZRole.SuperAdmin) {
            return <SurveyActivityV3ManagerScreen />
        }
    }
}

const select = state => ({ ...state.session });

export default connect(select)(SurveyActivityScreen);